/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MediaEpisodeDetailForm } from "./MediaEpisodeDetailForm";
import MediaEpisodeSegmentEditForm from "../Segment/MediaEpisodeSegmentEditForm";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import * as API from '../../framework/API/api';
import { ACCESS_LEVEL, ASSETTYPE, MEDIA_ATTACHMENT_TYPE, BA_ACTION, CONTENT_CUSTOM_ENUM, ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MEDIA_TRANSMISSION, MEDIACATEGORIES, MODULE, OTTROUTETYPE, PUBLISHING_SOURCE, SYNOPSIS_TYPE, TRANSMISSION_ACTION, TOAST_TYPES, ROLETYPE } from "../../framework/constant/constant";
import MediaEpisodePublishingEditForm from "./MediaEpisodePublishingEditForm";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { EditPageHeader } from "../../components/EditPageHeader";
import MediaEpisodeMataDataEditForm from "./MediaEpisodeMataDataEditForm";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmAlert, ConfirmDeleteAlert } from "../../ConfirmAlert";
import MediaEpisodeAssetEditForm from "./MediaEpisodeAssetEditForm";
import moment from "moment";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import SaveButton from "../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../framework/forms/helpercomponents/buttons/CancelButton";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { utility } from "../../framework/utility/utilityProvider";
import { DataHelper } from "../../framework/helper/DataHelper";
import FileAttachmentForm from "./FileAttachmentForm";
import MarkerEditForm from "./MarkerEditForm";
import BossDialog from "../../components/BossDialog";
import { MediaTemplateEditForm } from "./MediaTemplateEditForm";
import { GenreEditForm } from "../masters/GenreEditForm";
import BossAssistantIcon from "./component/BossAssistantIcon";
import { TransmissionBrowser } from "./NodeTreeView/TransmissionBrowser";
import AttachMediaCollectionSelection from "./attachmentMedia/AttachMediaCollectionSelection";
import ToastNotification from "../../components/ToastNotification";

export const MediaEpisodeEditForm = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const { SID } = useParams();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  let blankDataItem = {
    SID: SID,
    Content: {},
    Genres: [],
    SubGenres: [],
    MediaType: {},
    MediaSubType: {},
    Description: "",
    Title: props?.Title ?? '',
    Duration: "00:00:00:00",
    EpisodeTitle: "",
    AssetId: "",
    EpisodeNumber: 1,
    IsLive: false,
    ReferenceCode: '',
    IsMusic: false,
    MusicCategory: {},
    Transmission: { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
    AlwaysLive: false,
    Provider: {},
    TargetGroup: {},
    Channels: [],
    Platforms: [],
    isLinearUnlimitedRights: true,
    LinearStartDate: null,
    LinearEndDate: null,
    isNonLinearUnlimitedRights: true,
    NonLinearStartDate: null,
    NonLinearEndDate: null,
  }

  const mediaCategorySID = location?.state && location?.state?.isFromAddProgram ? location?.state?.dataItem.MediaSubCategoryType.MediaCategorySID : props.mediaCategory;

  const [mediaEpisodeEntity, setMediaEpisodeEntity] = useState(
    location.state && location.state.isFromAddProgram && location.state.dataItem ?
      { ...blankDataItem, ...location.state.dataItem } : blankDataItem);

  const [mediaEpisodeMetaData, setMediaEpisodeMetaData] = useState({
    PGRating: {},
    CensorRating: {},
    MediaTechnicalPrototype: {},
    Languages: [],
    Keywords: '',
    ProductionYear: "",
    Synopsis: [],
    CastAndCrew: [],
    MamID: '',
    AudioTrack: [],
    dynamicField: {},
    CensorshipDetail: [],
    Extension: {},
    DubbedLanguages: [],
    Country: {}
  });
  const [mediaEpisodeSegments, setMediaEpisodeSegments] = useState([]);
  const [deletedSegments, setDeletedSegments] = useState([]);

  const [tabNumber, setTabNumber] = React.useState("1");
  const [IMDbData, setIMDbData] = useState({});
  const [selectedMusicCategory, setSelectedMusicCategory] = useState({});

  const isAssestID = utility.isNumeric(SID) == false;
  const isEdit = isAssestID || SID > 0 ? true : false;

  const [disableSave, setDisableSave] = useState(isEdit ? false : true);
  const [showOttAssetEditForm, setShowOttAssetEditForm] = useState(false);
  const [mediaEpisodeDescription, setMediaEpisodeDescription] = useState("");
  const [openFormatSelectionCollection, setOpenFormatSelectionCollection] = useState(false);
  const [selectedFormats, setSelectedFormats] = useState([]);
  const [mediaCategory, setMediaCategory] = useState([]);
  const [assetDataItem, setAssetDataItem] = useState({});

  const [attachedMediaOpen, setAttachedMediaOpen] = useState(false);
  const [selectedAttachedMedia, setSelectedAttachedMedia] = useState([]);
  const [showMetaDataLocalization, setShowMetaDataLocalization] = useState(false);
  const [localizationData, setLocalizationData] = useState([]);
  const [allLanguages, setAllLanguages] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [pgRatings, setPGRatings] = useState([]);
  const [censorRatings, setCensorRatings] = useState([]);
  const [castTypes, setCastTypes] = useState([]);
  const [attachmentData, setAttachmentData] = useState([]);
  const [markerData, setMarkerData] = useState([]);

  const [openPublishingDialog, setOpenPublishingDialog] = useState(false);
  const [showMarkerEditForm, setShowMarkerEditForm] = useState(false);
  const [mediaTeplateOpen, setMediaTeplateOpen] = useState(false);
  const [isManualAssetId, setIsManualAssetId] = useState(false);

  const blankLocalizationStore = {
    SID: 0,
    Language: {},
    Genres: [],
    SubGenres: [],
    Title: '',
    Description: '',
    MetaData: {
      PGRating: {},
      CensorRating: {},
      MediaTechnicalPrototype: {},
      Languages: [],
      Keywords: '',
      ProductionYear: "",
      Synopsis: [],
      CastAndCrew: [],
      AudioTrack: [],
      dynamicField: {},
      CensorshipDetail: [],
      Categories: [],
      Extension: {},
      DubbedLanguages: [],
      Country: {}
    },
    MediaEpisode_id: ''
  }

  const [localizationStoreData, setLocalizationStoreData] = useState(blankLocalizationStore);
  //LIVE EVENTS
  const [liveEventDetails, setLiveEventDetails] = useState([]);
  const [isSaveMetaData, setIsSaveMetaData] = useState(false);
  const [mediaTemplateSelectionOpen, setMediaTemplateSelectionOpen] = useState(false);
  const [genres, setGenres] = useState([]);
  const [filterGenres, setFilterGenres] = useState([]);
  const [showGenreForm, setShowGenreForm] = useState(false);

  const lang = useTranslation();
  const userData = utility.getValue(LOCALSTORAGE_KEY.userData);
  const isSuperAdmin = userData?.RoleType?.ID == ROLETYPE.SuperAdmin

  useEffect(() => {
    loadCombo();
  }, [localizationStoreData?.Language])

  useEffect(() => {
    if (isEdit) {
      loadMediaEpisode();
    }
    setMediaEpisode();
  }, [SID]);

  const loadCombo = async () => {
    let pgRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPGRatings(pgRes.data);
    let crRes = await API.getDataLookup(ENTITYNAME.CensorRating, { sort: { Description: 1 } });
    setCensorRatings(crRes.data);
    let castTypeRes = await API.getDataLookup(ENTITYNAME.CastType, { sort: { Description: 1 }, query: ["Archive", "!=", true] });
    setCastTypes(castTypeRes.data);
    let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setAllLanguages(languagesRes.data);
    let filteredLanguages = languagesRes.data.filter((x) => x.Description !== company.Language.Description);
    setLanguages(filteredLanguages);

    let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
    setGenres(genreRes.data);

    if (localizationStoreData.Language && Object.keys(localizationStoreData.Language).length > 0) {
      let filterGenreData = genreRes.data.filter((item) => item?.Language?._id == localizationStoreData.Language?._id);
      setFilterGenres(filterGenreData);
    } else {
      setFilterGenres(genreRes.data);
    }
  }

  const onChangeLocalization = (e) => {
    if (e.target.name == 'Language') {
      let filterGenreData = genres.filter((item) => item?.Language?._id == e.target.value?._id);
      setFilterGenres(filterGenreData);
      setLocalizationStoreData({ ...localizationStoreData, Language: e.target.value, Genres: [], SubGenres: [], MetaData: blankLocalizationStore.MetaData });
    } else {
      setLocalizationStoreData({ ...localizationStoreData, [e.target.name]: e.target.value });
    }
  }

  const setMediaEpisode = async () => {
    let mediaCategoryData = await API.getDataLookup(ENTITYNAME.MediaCategory);
    setMediaCategory(mediaCategoryData.data);
    let mediaCategory = mediaCategoryData.data.find((item) => item.SID == props.mediaCategory);
    setMediaEpisodeDescription(mediaCategory.Description);
  }

  const handleFormatList = (dataList) => {
    let newData = utility.checkDuplicateInData(dataList, selectedFormats, 'Name')
    setSelectedFormats([...selectedFormats, ...newData]);
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  //todo : when meta data add is clicked then the metadata close and version opens
  const handleExpand = (bool) => {
    console.log("in");
  }

  const handleMetaData = (data) => {
    let metaData = { ...data }
    if (isEdit && mediaEpisodeMetaData.hasOwnProperty('_id')) {
      metaData = { _id: mediaEpisodeMetaData._id, ...data }
    }
    setIsSaveMetaData(true);
    setMediaEpisodeMetaData(metaData);
    setMediaEpisodeEntity((props) => ({
    ...props,
    WorkingTitle: DataHelper.getWorkingTitle({
        customTitle2: props?.CustomTitle?.Title2,
        title: props?.Title,
        seasonNumber: props?.SeasonNumber,
        episodeNumber: props?.EpisodeNumber,
        pgRating: metaData?.PGRating?.Description,
        dealReference: props?.DealReference
    })
}));
  }

  const handleDeletedSegments = (segmentObject) => {
    console.log(segmentObject);
    setDeletedSegments(() => [...deletedSegments, segmentObject]);
  }

  const handleSegmentData = (data) => {
    console.log(data);
    setMediaEpisodeSegments(data);
  }

  const loadMediaEpisode = async () => {

    let res = { message: "Not Valid", success: false };
    if (isAssestID) {
      res = await API.getEntityfromAssestID(ENTITYNAME.MediaEpisode, SID);
    } else {
      res = await API.getEntity(ENTITYNAME.MediaEpisode, parseInt(SID));
      if (!res.data) {
        res = await API.getEntityfromAssestID(ENTITYNAME.MediaEpisode, SID);
      }
    }

    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }

    let metaRes = await API.getData(ENTITYNAME.MediaEpisodeMetaData, { query: ['MediaEpisode_id', '=', res.data?._id?.toString()] });

    if (metaRes.success && metaRes.data.length > 0) {
      const metaData = metaRes.data[0];
      setMediaEpisodeMetaData(prev => ({ ...prev, ...metaData, Country: metaData?.Country ?? {} }));
    }

    setMediaEpisodeEntity({
      ...blankDataItem,
      ...res.data,
      Transmission: res?.data?.Transmission ? { _id: res?.data?.Transmission, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, res?.data?.Transmission) } : { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
      Content: {
        ...res?.data?.Content,
        Custom: metaRes?.data?.[0]?.Country && Object.keys(metaRes?.data?.[0]?.Country || {}).length > 0 ? CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP : null
      },
    });

    //FECTH FORMATS
    if (res.data?.Formats && res.data?.Formats.length > 0) {

      let resFormatData = await API.getData(ENTITYNAME.Format, { query: ['_id', 'in', res.data?.Formats] });
      let formats = resFormatData.success && resFormatData.data && resFormatData.data.length > 0 ? resFormatData.data : [];

      setSelectedFormats(formats ?? []);
    }

    // FECTH LOCALIZATION
    let resLocalizationData = await API.getData(ENTITYNAME.MediaEpisodeLocalization, { query: ['MediaEpisode_id', 'in', [res.data?._id]] });
    let localization = resLocalizationData.success && resLocalizationData.data && resLocalizationData.data.length > 0 ? resLocalizationData.data : [];
    setLocalizationData(localization ?? []);

    setMarkerData(res?.data?.Marker);
    //load asset details
    if (res?.data?.IsOttAsset) {
      let assetRes = await API.getData(ENTITYNAME.OttAsset, { query: [['Source._id', '=', res.data?._id], ['Source.entityName', '=', 'mediaepisode']] });
      console.log(assetRes.data)
      if (assetRes.data && assetRes.data.length > 0) {
        setAssetDataItem({ ...assetRes.data[0], IsOttAsset: res.data.IsOttAsset });
        setShowMarkerEditForm(true);
      }
    }
    //load live event details
    let liveEventDetails = await API.getData(ENTITYNAME.MediaEpisodeDetailLiveEvent, { query: ['MediaEpisode_id', '=', res.data?._id?.toString()] });
    setLiveEventDetails(liveEventDetails.data ?? []);
    if (liveEventDetails.data && liveEventDetails.data.length > 0) {
      handleTabChange({}, "8")
    }

    //load attached media
    let attachedMedia = await API.getData(ENTITYNAME.MediaEpisodeAttachMedia, { query: ['mediaEpisodeId', '=', res.data?._id?.toString()] });
    setSelectedAttachedMedia(attachedMedia.data ?? []);

    // load file Attachment 
    let fileAttachment = await API.getData(ENTITYNAME.FileAttachments, { query: ['MediaEpisode_id', '=', res.data?._id?.toString()] });
    setAttachmentData(fileAttachment.data);

    setSelectedMusicCategory(res?.data?.MusicCategory ?? {})

  }

  const handleSetMediaEpisodeEntity = async (data, IMDbData) => {

    let vodType = await API.getData(ENTITYNAME.VODType, { query: ['Name', '=', 'SVOD'] });
    let ottPosterType = await API.getData(ENTITYNAME.OttPosterType, { query: ['Description', '=', 'Portrait'] });
    let videoType = await API.getData(ENTITYNAME.OttVideoType, { query: ['Description', '=', 'HLS'] });
    let provider = await API.getData(ENTITYNAME.OttProvider, { query: ['IsDefault', '=', true] });

    let prepareAssetsData = {
      ...assetDataItem,
      Title: data?.Title,
      IsOttAsset: true,
      VodTypes: vodType?.data[0],
      routeType: OTTROUTETYPE.NoRoute,
      Provider: provider?.data?.length > 0 ? provider?.data[0] : {},
      Posters: [
        {
          Description: data?.Title,
          OttPosterType: ottPosterType?.data[0],
          Url: data?.ImageUrl
        }
      ],
      Videos: [
        {
          Description: "N/A",
          OttVideoType: videoType?.data[0],
          Url: "N/A"
        }
      ]
    }
    setAssetDataItem(prepareAssetsData);
    setMediaEpisodeMetaData({ ...IMDbData });
    setMediaEpisodeEntity(data);
  }

  const onFormatDelete = (dataItem) => {
    console.log("delete format started");
    setSelectedFormats((old) =>
      old.filter((item) => dataItem.SID !== item.SID)
    );
    console.log("delete platform end");
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
  };

  const MyFormatDeleteCommandCell = (props) => (
    <div className="flex-container martb">
      <div><DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => onFormatDelete(props.dataItem), () => { })} /></div>
    </div>
  )

  const handleSetDisableSave = (value) => {
    setDisableSave(value);
  }

  const saveMetaData = async (data) => {

    let mediaEpisodeMetaFinalData = {
      ...mediaEpisodeMetaData,
      Synopsis: mediaEpisodeMetaData && Array.isArray(mediaEpisodeMetaData?.Synopsis) && mediaEpisodeMetaData?.Synopsis?.map(x => {
        return {
          ...x,
          Language: {
            _id: x.Language._id,
            ISOCode: x.Language.ISOCode,
            GoogleApiCode: x.Language.GoogleApiCode,
            Description: x.Language.Description
          },
          Type: x?.Type
        }
      })
    }
    let metaDataSaveData = DataHelper.saveMetaDataEntity(mediaEpisodeMetaFinalData, data);
    console.log(metaDataSaveData);

    let responseMetaData = await API.saveData(ENTITYNAME.MediaEpisodeMetaData, {
      ...metaDataSaveData,
      MediaEpisodeSID: data.SID,
      MediaEpisode_id: data._id
    });

    if (!responseMetaData.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: responseMetaData.message });
      return;
    }

    setMediaEpisodeMetaData({
      PGRating: {},
      CensorRating: {},
      MediaTechnicalPrototype: {},
      Languages: [],
      Keywords: '',
      ProductionYear: "",
      Synopsis: [],
      AudioTrack: [],
      dynamicField: {},
      CensorshipDetail: [],
      Extension: {},
      DubbedLanguages: [],
      Country: {}
    });
  }

  const saveSegments = async (mediaEpisode = {}) => {
    console.log("saveSegments started", mediaEpisodeSegments);
    // if formats are attached we need to make sure segment of same format type is created in system
    // commented for now as per discussion with harsh sir by vishal on 10 Oct 2025
    // if (selectedFormats && selectedFormats.length > 0) {
    //   let formatsSegmentResponse = await API.createSegmentsBasedOnFormatsAttached(selectedFormats, mediaEpisodeEntity.SID);
    //   console.log(formatsSegmentResponse)
    // }

    // Updating Segments Extension Only
    if (mediaEpisode?._id && mediaEpisodeSegments?.length > 0) {
      let segmentUpdateData = mediaEpisodeSegments.map(x => { return { _id: x?._id, SegmentExtension: { ...x?.SegmentExtension, workingTitle: mediaEpisode?.WorkingTitle, dealReference: mediaEpisode?.DealReference } } });
      await API.bulkUpdate(ENTITYNAME.MediaEpisodeSegment, segmentUpdateData);
      console.log("Update Segments extension only");
      return;
    }

    /* Commented out this code because save and delete operations will be handled in real time. */

    // Deleting Segments
    // if (deletedSegments && deletedSegments.length > 0) {
    //   await API.deleteManyEntity(ENTITYNAME.MediaEpisodeSegment, { query: ["_id", "in", deletedSegments?.map(x => x?._id)] });
    //   console.log("deleted Segments");
    // }

    // // Saving Segments
    // if (mediaEpisodeSegments?.length > 0) {
    //   let segmentsEntity = mediaEpisodeSegments?.map(x => { return { ...x, MediaEpisodeSID: mediaEpisode?.SID, MediaEpisode_id: mediaEpisode?._id, SegmentExtension: { ...x?.SegmentExtension, workingTitle: mediaEpisode?.WorkingTitle, dealReference: mediaEpisode?.DealReference } } });
    //   await API.saveData(ENTITYNAME.MediaEpisodeSegment, segmentsEntity);
    //   console.log("Updated Segments");
    // }

    // // updating planning for media episode, if segment is created after doing planning without segment
    // if (mediaEpisodeEntity._id && mediaEpisodeSegments.length > 0) {
    //   await API.updateSegmentInPlanning(mediaEpisodeEntity._id);
    //   console.log("Updated segments in planning");
    // }

  }

  const saveLogsFunction = (media_id, res, resMediaDealRights, assetsData) => {

    let inEdit = mediaEpisodeEntity.SID != 0;

    let logData = {
      data: {
        ...res.data, MediaDealRights: resMediaDealRights?.data, mediaEpisodeSegments: mediaEpisodeSegments, ...mediaEpisodeMetaData, _id: media_id, AttchMedia: selectedAttachedMedia, Assets: assetsData
      },
      message: res.message
    }

    // Log Capture
    if (props.mediaCategory == MEDIACATEGORIES.Program) {
      logData = {
        ...logData,
        event: inEdit ? LOGEVENT.UPDATE_PROGRAM : LOGEVENT.CREATE_PROGRAM,
        module: MODULE.MEDIA_EPISODE_PROGRAM,
      };
    } else if (props.mediaCategory == MEDIACATEGORIES.Movie) {
      logData = {
        ...logData,
        event: inEdit ? LOGEVENT.UPDATE_EPISODE : LOGEVENT.CREATE_EPISODE,
        module: MODULE.MEDIA_EPISODE_MOVIE,
      };
    } else {
      logData = {
        ...logData,
        event: inEdit ? LOGEVENT.UPDATE_TRAILER : LOGEVENT.CREATE_TRAILER,
        module: MODULE.MEDIA_EPISODE_TRAILER
      };
    }
    API.SaveLogs(logData);

  }

  const onSave = async () => {

    if (mediaEpisodeMetaData?.Extension?.subtitleLanguages && /[^\p{L}\p{N}\s;]|;;/u.test(mediaEpisodeMetaData.Extension.subtitleLanguages)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.subtitle_languages_error_message });
      return;
    }

    let localmediaEpisodeEntity = { ...mediaEpisodeEntity };

    const media_id = localmediaEpisodeEntity._id;

    console.log(markerData)
    let saveData = {
      ...localmediaEpisodeEntity,
      IMDbID: Object.keys(IMDbData).length > 0 ? IMDbData?.imdbID : "",
      IsMusic: localmediaEpisodeEntity.IsMusic ?? false,
      MusicCategory: localmediaEpisodeEntity.IsMusic ? { _id: selectedMusicCategory?._id, SID: selectedMusicCategory?.SID, Name: selectedMusicCategory?.Name } : {},
      ReferenceCode: localmediaEpisodeEntity.ReferenceCode ?? localmediaEpisodeEntity.AssetId,
      Formats: selectedFormats && selectedFormats.length > 0 ? selectedFormats.map(a => a?._id) : [],
      IsOttAsset: assetDataItem.IsOttAsset ?? false,
      MaterialID: mediaEpisodeSegments.some(x => x?.IsDefault) ? mediaEpisodeSegments.find(x => x?.IsDefault)?.SegmentNumber : "",
      Marker: markerData ?? [],
      Provider: localmediaEpisodeEntity.Provider?._id ? { _id: localmediaEpisodeEntity.Provider?._id, Description: localmediaEpisodeEntity.Provider?.Description } : {},
    }

    let data = DataHelper.saveMediaEpisodeEntity(saveData, mediaEpisodeEntity.MediaCategory, assetDataItem.IsOttAsset);

    if (data?._id && data?._id.toString().length > 0) {
      delete data._id
    }

    if (assetDataItem.IsOttAsset && !isValidAsset()) {
      return;
    }

    if (data.SID == 0 && !isManualAssetId) {

      if (localmediaEpisodeEntity.Content.Custom && localmediaEpisodeEntity.Content.Custom > 0) {
        let media = {
          Title: localmediaEpisodeEntity.Title,
          ProductionYear: mediaEpisodeMetaData.ProductionYear,
          Languages: mediaEpisodeMetaData.Languages,
          DubbedLanguages: mediaEpisodeMetaData.DubbedLanguages,
          MediaCategory: localmediaEpisodeEntity.MediaCategory,
          SeasonNumber: localmediaEpisodeEntity.SeasonNumber ? parseInt(localmediaEpisodeEntity.SeasonNumber) : 0, // FOR Movie/Program
          EpisodeNumber: localmediaEpisodeEntity.EpisodeNumber ? parseInt(localmediaEpisodeEntity.EpisodeNumber) : 0, // FOR Movie/Program
          Country: mediaEpisodeMetaData?.Country,
          MediaType: localmediaEpisodeEntity.MediaType
        }
        data.AssetId = await DataHelper.getNewAssetId(localmediaEpisodeEntity.Content, true, media);;
      } else {
        data.AssetId = await DataHelper.getNewAssetId(localmediaEpisodeEntity.Content, true);
      }

    }

    let res = await API.saveData(ENTITYNAME.MediaEpisode, data);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }

    //UPDATE EPISODE COUNT IN SEASON IF MEDIA CATEGPRY EPISODE
    if (res.data.MediaCategory.SID == MEDIACATEGORIES.Episode) {
      await API.updateSeasonEpisodeCount({
        data: res.data, //episode saved entity
        entityName: ENTITYNAME.MediaEpisode
      });
    }

    let resMediaDealRights = {};
    // New saving of deal rights
    if (SID == 0) {
      let transmissionTypes = await API.getDataLookup(ENTITYNAME.TransmissionTypes);
      let defaultDealRightsData = DataHelper.getDefaultDealRights({ transmissionType: transmissionTypes?.data?.find(x => x?.Name?.toLowerCase() === "svod"), isLinearUnlimitedRights: saveData?.isLinearUnlimitedRights, linearStartDate: saveData?.LinearStartDate, linearEndDate: saveData?.LinearEndDate, isNonLinearUnlimitedRights: saveData?.isNonLinearUnlimitedRights, nonLinearStartDate: saveData?.NonLinearStartDate, nonLinearEndDate: saveData?.NonLinearEndDate, channels: saveData?.Channels, platforms: saveData?.Platforms, publishingSource: PUBLISHING_SOURCE.MediaEpisode })
      resMediaDealRights = await API.createAndUpdateDealRights(defaultDealRightsData, res.data._id);
    }

    //META DATA TAB SAVE
    if (isSaveMetaData) {
      await saveMetaData(res.data);
    }

    //VERSION TAB SAVE
    await saveSegments(res.data);

    //OTT ASSET TAB SAVE
    let assetsData = {};
    if (assetDataItem.IsOttAsset) {
      let assetRes = await onAssetSubmit({ ...res.data, _id: media_id });
      if (assetRes.success) {
        assetsData = assetRes.data
      }
    }

    // Log Capture
    saveLogsFunction(media_id, res, resMediaDealRights, assetsData);
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Saved Successfully" });
    setMediaEpisodeEntity(res.data);

    if (props.quickEdit) {
      navigate(location.state.prevPath);
    } else {
      let findIndex = location?.state?.prevPath?.indexOf("?");
      let pagination = location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "";
      let state = {
        ...location.state,
        quickEdit: false,
        prevPath: location?.state?.prevPath,
        pagination: location?.state?.pagination ?? pagination,
        paths: location?.state?.paths
      }
      navigate(
        SID == 0 ? `${location.pathname.slice(0, location.pathname.lastIndexOf("/"))}/${res.data.SID}` : location.pathname,
        { state: state }
      );
    }

  }

  //asset
  const setAssetEntity = (entity) => {
    setAssetDataItem(entity);
  }

  function isValidAsset() {

    let routeTypeID = typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType;

    if (!assetDataItem.VodTypes || Object.keys(assetDataItem.VodTypes).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_type_validation_error_message });
      return false;
    }

    if (!routeTypeID || routeTypeID === "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_route_type_error_message });
      return false;
    }

    if ((assetDataItem.routeType == (OTTROUTETYPE.Page || OTTROUTETYPE.PiPage) || assetDataItem.routeType.ID == (OTTROUTETYPE.Page || OTTROUTETYPE.PiPage)) && (assetDataItem.page_id == "" || assetDataItem.page_id == undefined)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page });
      return false;
    }

    if ((assetDataItem.routeType == OTTROUTETYPE.Player || assetDataItem.routeType.ID == OTTROUTETYPE.Player)
      && assetDataItem.Videos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
      return false;
    }

    let videosArr = utility.getItemDisplayValueByLang(assetDataItem.Videos, company.Language)
    if (routeTypeID == OTTROUTETYPE.Deeplink && !videosArr.some(x => x.OttVideoType?.Description === "Deeplink")) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_deeplink_in_video_list_error_message });
      return false;
    }

    if (assetDataItem.Videos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
      return false;
    }

    if (assetDataItem.Posters.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_poster_error_message });
      return false;
    }

    return true;
  }

  const onAssetSubmit = async (mediaEpisodeEntity) => {

    //MUTILANG TITLE & DESCRIPTION
    let title = assetDataItem.Title && assetDataItem.Title.length > 0 ? assetDataItem.Title : [
      {
        langISO: company.Language.ISOCode,
        value: mediaEpisodeEntity.Title
      }
    ];
    let description = assetDataItem.Description && assetDataItem.Description.length > 0 ? assetDataItem.Description : [
      {
        langISO: company.Language.ISOCode,
        value: assetDataItem.Description
      }
    ];
    
    let saveData = {
      _id: assetDataItem?._id,
      Title: title,
      Description: description,
      TBA: assetDataItem.TBA ?? false,
      StartDate: assetDataItem.StartDate ? new Date(assetDataItem.StartDate).getTime() : new Date(moment(new Date()).format('YYYY-MM-DD')).getTime(),
      EndDate: assetDataItem.EndDate ? new Date(assetDataItem.EndDate).getTime() : new Date(moment(new Date()).add(1, 'M').format('YYYY-MM-DD')).getTime(),
      OttAssetTypeSID: ASSETTYPE['Media Asset'],
      VodTypes: assetDataItem?.VodTypes?._id ? {
        _id: assetDataItem.VodTypes._id,
        SID: assetDataItem.VodTypes.SID,
        Name: assetDataItem.VodTypes.Name
      } : {},
      Provider: assetDataItem?.Provider?._id ? assetDataItem?.Provider?._id : "",
      Archive: assetDataItem.Archive ?? false,
      Source: { _id: mediaEpisodeEntity._id, SID: mediaEpisodeEntity.SID, Title: mediaEpisodeEntity.Title, MediaCategory: mediaEpisodeEntity.MediaCategory, entityName: ENTITYNAME.MediaEpisode },
      routeType: typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType,
      page_id: typeof assetDataItem.page_id === 'object' ? assetDataItem.page_id._id : assetDataItem.page_id,
      Videos: assetDataItem.Videos ?? [],
      Posters: assetDataItem.Posters ?? [],
      RentalRetailPrice: assetDataItem.VodTypes.Name == 'TVOD' ? assetDataItem.RentalRetailPrice : 0,
      RentalWholesalePrice: assetDataItem.VodTypes.Name == 'TVOD' ? assetDataItem.RentalWholesalePrice : 0,
      WebAssets: assetDataItem?.WebAssets ? assetDataItem?.WebAssets?._id : null,
      accessLevel: assetDataItem?.accessLevel?._id ?? ACCESS_LEVEL.Both,
      SubTitles: assetDataItem?.SubTitles && assetDataItem?.SubTitles.length > 0 ? assetDataItem?.SubTitles : [],
      thumbnailUrl: assetDataItem?.thumbnailUrl ?? "",
      Segments: (assetDataItem?.Segments && assetDataItem?.Segments?.length > 0) ? assetDataItem?.Segments?.map((x) => {
        return {
          _id: x?._id,
          Description: x?.Description
        }
      }) : []
    }

    if (assetDataItem._id != undefined) {
      saveData._id = assetDataItem._id;
      saveData.SID = assetDataItem.SID
    }
    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.OttAsset, saveData);
    let logData = { event: res.message == "inserted" ? LOGEVENT.CREATE_ASSETS : LOGEVENT.UPDATE_ASSETS, module: MODULE.OTT_ASSETS, data: res.data, message: res.message };
    API.SaveLogs(logData);
    return res;
  };

  const handleAttachedMediaSelect = async (dataList = []) => {

    if (!mediaEpisodeEntity?._id) {
      ToastNotification({ message: lang.please_save_media_first_error_message });
      return;
    }

    console.log(dataList);

    let newAttachedMedia = [];
    for (const item of dataList) {

      const isLong = item?.MediaCategory?.isLong || item?.MediaEpisode?.MediaCategory?.isLong;
      let attachedMediaDataEntity = {
        attachedMedia: {
          _id: item?._id,
          SID: item?.SID,
          Title: isLong ? item?.MediaEpisode?.Title : item?.Title,
          AssetId: isLong ? item?.MediaEpisode?.AssetId : item?.AssetId,
          MediaCategory: isLong ? item?.MediaEpisode?.MediaCategory : item?.MediaCategory,
          Type: isLong ? MEDIA_ATTACHMENT_TYPE.SEGMENT : MEDIA_ATTACHMENT_TYPE.MEDIAEPISODE
        },
        srcId: mediaEpisodeEntity._id,
        srcType: ENTITYNAME.MediaEpisode,
        mediaEpisodeId: mediaEpisodeEntity._id
      }

      newAttachedMedia.push(attachedMediaDataEntity);
    }

    // Remove duplicates
    const finalAttachedMedia = newAttachedMedia.filter((item) => {
      return !selectedAttachedMedia.some(
        (x) => x?.attachedMedia?._id == item?.attachedMedia?._id
      );
    });

    if (finalAttachedMedia.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.already_attached_collection_error_message });
      return;
    }


    let response = await API.createAndUpdateAttachMedias(finalAttachedMedia);
    const attachedMediaData = response?.data ?? [];

    setSelectedAttachedMedia([...selectedAttachedMedia, ...attachedMediaData]);
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_attached_success_message });
  }

  const MyAttachMediaCommandCell = (props) => (
    <div style={{ display: "flex" }}>
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteAttachedMedia(props.dataItem), () => { })} />
    </div>
  )


  const deleteAttachedMedia = async (dataItem = {}) => {
    let response = await API.deleteAttachedMedias({ query: ["_id", "=", dataItem._id] });
    if (!response.success) {
      ToastNotification({ message: response.message });
    } else {
      let filterAttachedMedia = selectedAttachedMedia.filter(x => x._id != dataItem._id);
      setSelectedAttachedMedia(filterAttachedMedia);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    }
  }

  const handleMetaDataLocaliztaion = async (data) => {
    let dataStore = {
      _id: localizationStoreData._id,
      SID: localizationStoreData.SID,
      MediaEpisode_id: localizationStoreData.MediaEpisode_id,
      Language: {
        _id: localizationStoreData.Language._id,
        SID: localizationStoreData.Language.SID,
        Description: localizationStoreData.Language.Description,
        ISOCode: localizationStoreData.Language.ISOCode
      },
      MetaData: data,
      Title: localizationStoreData?.Title,
      Description: localizationStoreData?.Description,
      Genres: localizationStoreData?.Genres?.length > 0 ? localizationStoreData?.Genres?.map((x) => ({
        _id: x?._id,
        Description: x?.Description
      })) : [],
      SubGenres: localizationStoreData?.SubGenres?.length > 0 ? localizationStoreData?.SubGenres?.map((x) => ({
        _id: x?._id,
        Description: x?.Description
      })) : [],
    }
    setLocalizationStoreData(dataStore);
  }

  const onSaveLocalizationData = async () => {
    if (!localizationStoreData?.Language || Object.keys(localizationStoreData?.Language).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_language_error_message });
      return;
    }

    // Check for duplicates in `localizationData`
    const isDuplicate = localizationData.some((item) => (item?._id != localizationStoreData?._id && item?.Language?._id == localizationStoreData?.Language?._id));
    if (isDuplicate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: localizationStoreData?.Language?.Description + ` ${lang.already_exists_global_error_message}` });
      return;
    }

    let finalData = DataHelper.saveMediaEpisodeLocalizationEntity(localizationStoreData, mediaEpisodeEntity);
    let res = await API.saveData(ENTITYNAME.MediaEpisodeLocalization, finalData);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: responseMetaData.message });
      return;
    }

    if (res.message === 'inserted') {
      setLocalizationData([...localizationData, res.data]);
    } else {
      let updateLocalizationData = localizationData.map((x) => {
        if (x._id == res.data._id) {
          return res.data;
        } else {
          return x
        }
      });
      setLocalizationData(updateLocalizationData);
    }

    setShowMetaDataLocalization(false);
    setLocalizationStoreData(blankLocalizationStore);
  };

  const removeLocalization = async (dataItem) => {
    let filterGenres = localizationData.filter(x => x._id != dataItem._id);
    setLocalizationData(filterGenres);
    await API.deleteData(ENTITYNAME.MediaEpisodeLocalization, dataItem._id, "_id");
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
  }

  const editLocalizationGridData = async (dataItem) => {
    setShowMetaDataLocalization(true);
    setLocalizationStoreData(dataItem);
  }

  const CommandCellLocalization = (props) => {
    return (
      <div className="flex-container martb">
        <EditRoundButton onClick={() => editLocalizationGridData(props.dataItem)} />
        <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeLocalization(props.dataItem), () => { })} />
      </div>
    );
  }

  const onCancelLocalization = () => {
    setLocalizationStoreData(blankLocalizationStore);
    setShowMetaDataLocalization(!showMetaDataLocalization);
  }

  const onCancel = () => {

    //OLD
    // () => history.length > 1 ? navigate(-1) : window.close()

    console.log(mediaEpisodeEntity);
    console.log(location.state)

    if (mediaEpisodeEntity.SID == 0) {

      ConfirmAlert(() => {
        if (location.state && location.state.prevPath) {
          navigate(location.state.prevPath)
        } else {
          navigate(-1) ? navigate(-1) : window.close();
        }
      }, () => { return; }, "Discard changes?", "Are you sure you want to discard changes?")
    } else {
      if (location.state && location.state.prevPath) {
        let state = {
          ...location.state,
          pagination: location.state.pagination ?? "",
          prevPath: location?.state?.prevPath,
          paths: location.state.paths.slice(0, -1)
        }
        navigate(location.state.paths.length == 1 ? location.state.paths.pop() + location.state.pagination ?? "" : location.state.paths.pop(), { state: state })
      } else {
        navigate(-1) ? navigate(-1) : window.close();
      }
    }
  }

  const onSetSelectedMediaEpisode = async (dataList) => {
    setIsSaveMetaData(true);
    setMediaEpisodeMetaData({ ...mediaEpisodeMetaData, ...dataList[0].Value.metaData });
  }

  //ON BOSS ASSISTANT ICON CLICK
  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.FullMetaData, item, mediaEpisodeEntity);
    console.log(aiDataRes);
    return aiDataRes;

  }

  //FUNCTION FOR FETCHING META DATAFROM BOSS AI
  const setMetaData = (data) => {

    console.log("HERE IN MEDIA EPISODE")
    console.log(data);

    setMediaEpisodeEntity({
      ...mediaEpisodeEntity,
      Title: data.Title,
      Description: data.Description && data.Description.length > 0 ? data.Description : mediaEpisodeEntity.Description,
      Genres: genres.filter((x) => x.Description.toLowerCase() == data.Genre.toLowerCase()),
      SubGenres: genres.filter((x) => x.Description.toLowerCase() == data.SubGenre.toLowerCase()),
    });

    let synopsisData = data.Synopsis.map((item) => {
      let language = allLanguages.find((x) => x.Description == item.Language.Description);
      if (!language) {
        //SETTING ENGLISH DEFAULT
        language = allLanguages.find((x) => x.Description == "English");
      }
      return {
        Language: { _id: language?._id, SID: language.SID, Description: language.Description, ISOCode: language?.ISOCode, GoogleApiCode: language?.GoogleApiCode },
        Synopsis: item.Synopsis,
        Type: SYNOPSIS_TYPE.Long
      };
    })

    synopsisData = [...Array.from(new Set([...mediaEpisodeMetaData.Synopsis, ...synopsisData]))];


    let castAndCrewData = data.CastAndCrew.map((item) => {
      let cast = castTypes.find((x) => x.Description == item.CastType.Description);
      if (!cast) {
        //SETTING CAST TYPE DEFAULT
        cast = castTypes.find((x) => x.Description == "Cast");
      }
      return {
        Name: item.Name,
        CastType: cast,
      };
    })

    castAndCrewData = [...Array.from(new Set([...mediaEpisodeMetaData.CastAndCrew, ...castAndCrewData]))];

    let newMetaData = {
      ...mediaEpisodeMetaData,
      PGRating: pgRatings.find((x) => x.Description.toLowerCase() == data.PGRating.toLowerCase()) ?? mediaEpisodeMetaData.PGRating,
      CensorRating: censorRatings.find((x) => x.Description.toLowerCase() == data.CensorRating.toLowerCase()) ?? mediaEpisodeMetaData.CensorRating,
      Languages: data.Languages.map((x) => {
        let lan = allLanguages.find((y) => y.Description.toLowerCase() == x.toLowerCase());
        return { _id: lan._id, SID: lan.SID, Description: lan.Description, ISOCode: lan?.ISOCode }
      }) ?? mediaEpisodeMetaData.Languages,
      Keywords: data.Keywords ?? mediaEpisodeMetaData.Keywords,
      ProductionYear: data.ProductionYear ?? mediaEpisodeMetaData.ProductionYear,
      MamID: data.MamID ?? mediaEpisodeMetaData.MamID,
      Synopsis: synopsisData ?? mediaEpisodeMetaData.Synopsis,
      CastAndCrew: castAndCrewData ?? mediaEpisodeMetaData.CastAndCrew,
      DubbedLanguages: data.DubbedLanguages.map((x) => {
        let lan = allLanguages.find((y) => y.Description.toLowerCase() == x.toLowerCase());
        return { _id: lan._id, SID: lan.SID, Description: lan.Description, ISOCode: lan?.ISOCode }
      }) ?? mediaEpisodeMetaData.DubbedLanguages,
      Country: mediaEpisodeMetaData?.Country ?? {}
    }

    console.log(newMetaData)
    setMediaEpisodeMetaData(newMetaData)
    setIsSaveMetaData(true);

  }

  return (<>

    <EditPageHeader title={mediaEpisodeDescription + " -> " + (mediaEpisodeEntity ? mediaEpisodeEntity.Title : `${lang.new_button_dialog_header}`)} disableSave={disableSave} onSubmit={onSave} onCancel={onCancel} showMediaTemplate={true} onSaveAndCreateMediaTemplate={() => setMediaTeplateOpen(true)} onSelectMediaTemplate={() => setMediaTemplateSelectionOpen(true)} defaultLanguage={company.Language.Description ?? ""} />

    <MediaEpisodeDetailForm
      dataItem={mediaEpisodeEntity}
      setDataItem={setMediaEpisodeEntity}
      mediaCategory={mediaCategorySID}
      mediaCategoryType={location?.state && location?.state?.isFromAddProgram ? location?.state?.dataItem.MediaSubCategoryType.MediaCategoryTypeSID : props.mediaCategoryType}
      setMediaEpisodeData={handleSetMediaEpisodeEntity}
      setSaveState={handleSetDisableSave}
      quickEdit={location?.state?.quickEdit ?? false}
      IMDbData={IMDbData} setIMDbData={setIMDbData}
      selectedMusicCategory={selectedMusicCategory}
      setSelectedMusicCategory={setSelectedMusicCategory}
      metaData={mediaEpisodeMetaData}
      setMediaEpisodeMetaData={handleMetaData}
      onSave={onSave}
      isFromAddProgram={location?.state?.isFromAddProgram ?? false}
      isManualAssetId={isManualAssetId}
      setIsManualAssetId={setIsManualAssetId}
    />

    <div className='row'>
      <div className='col-12'> <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabNumber}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <TabList onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
                {liveEventDetails.length > 0 && <Tab label={lang.live_event_details} value="8" />}
                <Tab label={lang.meta_data_label} value="1" />
                <Tab label={lang.version_label} value="2" />
                <Tab label={lang.publishing_label} value="3" />
                <Tab label={lang.ott_assets_collection_header} value="4" />
                <Tab label={lang.format_label} value="5" />
                <Tab label={lang.attach_media_label} value="6" />
                {mediaEpisodeEntity.SID > 0 && <Tab label={lang.media_episode_localization} value="7" />}
                <Tab label={lang.attachments_label} value="9" />
                {showMarkerEditForm && <Tab label={lang.marker_label} value="10" />}
                <Tab label={lang.transmission_label} value="11" />
              </TabList>
              <BossAssistantIcon
                style={{}}
                mediaEpisodeEntity={mediaEpisodeEntity}
                onDataLoad={onBossAIMetaDataLoad}
                tooltip={"Generate full meta data with Boss AI"}
                description={"BOSS AI Generating Meta Data"}
                setMetaData={setMetaData}
              />
            </Box>
          </Box>
          <TabPanel value="1">
            <MediaEpisodeMataDataEditForm language={company.Language ?? {}} mediaData={mediaEpisodeEntity} SID={mediaEpisodeEntity.SID} metaData={mediaEpisodeMetaData} getMetaData={handleMetaData} expand={handleExpand} />
          </TabPanel>
          <TabPanel value="2">
            <MediaEpisodeSegmentEditForm SID={mediaEpisodeEntity.SID} segmentData={mediaEpisodeSegments} getSegmentData={handleSegmentData} metaData={mediaEpisodeMetaData} handleMetaData={handleMetaData} mediaEpisodeEntity={mediaEpisodeEntity} audioTrack={mediaEpisodeMetaData.AudioTrack} handleDeletedSegments={handleDeletedSegments} />
          </TabPanel>
          <TabPanel value="3">
            <div className="row">
              <MediaEpisodePublishingEditForm
                mediaCategory={mediaCategory.find((obj) => obj.SID == props.mediaCategory) ?? { isLong: true }}
                mediaEpisodeEntity={mediaEpisodeEntity}
                publishingSource={PUBLISHING_SOURCE.MediaEpisode}
                openPublishingDialog={openPublishingDialog}
                setOpenPublishingDialog={setOpenPublishingDialog}
                isNewMedia={!isEdit}
              />
            </div>
          </TabPanel>
          <TabPanel value="4">
            <div className="row" style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "30px 20px 30px 10px" }}>
              {/* NEED TO ASK FOR LANGUAGE CURRENTLY PASSING COMPANY LANGUAGE */}
              <MediaEpisodeAssetEditForm
                source={'mediaepisode'}
                sourceEntity={mediaEpisodeEntity}
                entityname={ENTITYNAME.OttAsset}
                setDataEntity={setAssetEntity}
                dataItem={assetDataItem}
                selectedLanguage={company.Language}
              />
            </div>
          </TabPanel>
          <TabPanel value="5">
            <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
              <AddRoundButton style={{ marginBottom: '5px' }} onClick={() => setOpenFormatSelectionCollection(true)} />
              <Grid data={selectedFormats} style={{ height: "30vh" }}>
                <GridColumn cell={MyFormatDeleteCommandCell} width="40px" locked={true} />
                <GridColumn field="Name" title={lang.name_column} editable={false} />
                <GridColumn field="SegmentType.Description" title={lang.segment_type_column} editable={false} />
              </Grid>
              {openFormatSelectionCollection && <CollectionSelection entityname={ENTITYNAME.Format} title={lang.select_format_collection} wherestatement={[['SID', '>', 0], ...(!isSuperAdmin ? [["Channel._id", "in", userData?.Channels ?? []]] : [])]} closeForm={() => setOpenFormatSelectionCollection(!openFormatSelectionCollection)} setDataList={handleFormatList} width="50vw" />}
            </div>
          </TabPanel>
          {mediaEpisodeEntity.SID > 0 && <TabPanel value="6">
            <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
              <RoundButton style={{ marginBottom: '5px' }} icon={'link'} title={lang.attach_media_button_tooltip} onClick={() => setAttachedMediaOpen(true)} />
              <Grid resizable data={selectedAttachedMedia} style={{ height: "30vh" }}>
                <GridColumn cell={MyAttachMediaCommandCell} width="40px" locked={true} />
                <GridColumn field="attachedMedia.AssetId" title={lang.assetId_column} editable={false} />
                <GridColumn field="attachedMedia.Title" title={lang.title_column} editable={false} />
                <GridColumn field="attachedMedia.MediaCategory.Description" title={lang.media_category_column} editable={false} />
              </Grid>
            </div>
          </TabPanel>}
          {mediaEpisodeEntity.SID > 0 && <TabPanel value="7">
            <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
              <AddRoundButton style={{ marginBottom: '5px' }} onClick={() => setShowMetaDataLocalization(true)} />
              <Grid data={localizationData}
                style={{ height: "30vh" }}>
                <GridColumn cell={CommandCellLocalization} width="70px" />
                <GridColumn field="Title" title={lang.title_label} />
                <GridColumn field="Description" title={lang.description_label} />
                <GridColumn field="Language.Description" title={lang.language_column} />
              </Grid>
            </div>
          </TabPanel>}
          {liveEventDetails.length > 0 && <TabPanel value="8">
            <div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="row">
                    <div className="col-6 form-group">
                      <label htmlFor="TabView">{lang.team_a_label}</label>
                      <input className="pl-2" type="text" style={{ border: 'solid lightgrey 1px', height: "35px" }} name={"TeamA"} onChange={() => { }} value={liveEventDetails[0].TeamA} disabled={true} />
                    </div>
                    <div className="col-6 form-group">
                      <label htmlFor="TabView">{lang.team_b_label}</label>
                      <input className="pl-2" type="text" style={{ border: 'solid lightgrey 1px', height: "35px" }} name={"TeamB"} onChange={() => { }} value={liveEventDetails[0].TeamB} disabled={true} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group">
                      <label htmlFor="TabView">{lang.type_label} </label>
                      <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={[]}
                        name="Type"
                        textField="Description"
                        dataItemKey="SID"
                        value={liveEventDetails[0].Type}
                        onChange={() => { }}
                        validator={(value) => value ? "" : "Please select the value"}
                        disabled={true}
                      />
                    </div>
                    <div className="col-6 form-group">
                      <label htmlFor="TabView">{lang.round_label} </label>
                      <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={[]}
                        name="Round"
                        textField="Description"
                        dataItemKey="SID"
                        value={liveEventDetails[0].Round}
                        onChange={() => { }}
                        validator={(value) => value ? "" : "Please select the value"}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3 form-group">
                      <label htmlFor="TabView">{lang.start_date_label} </label>
                      <input type="date" className="form-control form-control-sm" name="StartDate" value={moment(new Date(liveEventDetails[0].StartDateTime)).format('YYYY-MM-DD')} onChange={() => { }} disabled={true} />
                    </div>
                    <div className="col-3">
                      <label htmlFor="">{lang.start_time_label} </label>
                      <TimePickerWithFormat className="form-control form-control-sm" name="StartTime" value={moment(new Date(liveEventDetails[0].StartDateTime)).utc().format('hh:mm:ss:SS')} onChange={() => { }} disabled={true} />
                    </div>
                    <div className="col-6">
                      <label htmlFor="">{lang.duration_label} </label>
                      <TimePickerWithFormat className="form-control form-control-sm" name="Duration" value={utility.convertMilisecondsToStringWithFrames(liveEventDetails[0].Duration)} onChange={() => { }} disabled={true} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group">
                      <label htmlFor="">{`${lang.team_a_poster_url_label} (Optional)`}</label>
                      <input
                        name={"TeamAPosterUrl"}
                        className="form-control form-control-sm"
                        type={'text'}
                        value={liveEventDetails[0].TeamAPosterUrl}
                        onChange={() => { }}
                        disabled={true}
                      />
                    </div>
                    <div className="col-6 form-group">
                      <label htmlFor="">{`${lang.team_b_poster_url_label} (Optional)`}</label>
                      <input
                        name={"TeamBPosterUrl"}
                        className="form-control form-control-sm"
                        type={'text'}
                        value={liveEventDetails[0].TeamBPosterUrl}
                        onChange={() => { }}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group">
                      <label htmlFor="TabView">{`Venue (Optional)`}</label>
                      <input className="pl-2" type="text" style={{ border: 'solid lightgrey 1px', height: "35px" }} name={"Venue"} onChange={() => { }} value={liveEventDetails[0].Venue} disabled={true} />
                    </div>
                    <div className="col-6">
                      <label htmlFor="">{`Poster Url (Optional)`}</label>
                      <input
                        name={"PosterUrl"}
                        className="form-control form-control-sm"
                        type={'text'}
                        value={liveEventDetails[0].PosterUrl}
                        onChange={() => { }}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>}
          <TabPanel value="9">
            <FileAttachmentForm MediaEpisode_id={mediaEpisodeEntity._id} setAttachmentData={setAttachmentData} attachmentData={attachmentData} />
          </TabPanel>
          {showMarkerEditForm &&
            <TabPanel value="10">
              <MarkerEditForm MediaEpisode_id={mediaEpisodeEntity._id} setMarkerData={setMarkerData} markerData={markerData} />
            </TabPanel>}
          <TabPanel value="11">
            <div className="row">
              <TransmissionBrowser isFromMedia={true} selectedNode={mediaEpisodeEntity} showToggle={true} query={["mediaEpisode._id", "=", mediaEpisodeEntity?._id]} mainStyle={{ height: 'calc(100vh - 300px)' }} gridStyle={{ height: 'calc(100vh - 525px)' }} entityName={ENTITYNAME.MediaEpisode} />
            </div>
          </TabPanel>
        </TabContext>
      </Box>
      </div>
      {showMetaDataLocalization && <BossDialog
        title={lang.localization_dialog_header}
        onClose={onCancelLocalization}
        width={"950px"}
      >
        <div className="row">
          <div className="col-6">
            <SaveButton onClick={onSaveLocalizationData} ></SaveButton>
            <CancelButton onClick={onCancelLocalization} ></CancelButton>
          </div>
          <div className="col-1 mt-1">
            <label>{lang.language_label}:</label>
          </div>
          <div className="col">
            <DropDownList
              data={languages}
              textField="Description"
              dataItemKey="_id"
              value={localizationStoreData.Language}
              onChange={onChangeLocalization}
              name={"Language"}
            />
          </div>
        </div>
        <div className="mt-3">
          <div className="row">
            <div className={mediaCategorySID === MEDIACATEGORIES.Episode ? "col-6" : "col-12"}>
              <label htmlFor="">{lang.title_label}</label>
              <input type="text" className="form-control form-control-sm" name="Title" value={localizationStoreData.Title} onChange={onChangeLocalization} />
            </div>
            {mediaCategorySID === MEDIACATEGORIES.Episode && <div className="col-6">
              <label htmlFor="">{lang.episode_title_label}</label>
              <input type="text" className="form-control form-control-sm" name="EpisodeTitle" value={localizationStoreData.EpisodeTitle} onChange={onChangeLocalization} />
            </div>}
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <label htmlFor="">{lang.description_label}</label>
              <input type="text" className="form-control form-control-sm" name="Description" value={localizationStoreData.Description} onChange={onChangeLocalization} />
            </div>
            <div className="col-6">
              <label htmlFor="">{lang.short_title_label}</label>
              <input type="text" className="form-control form-control-sm" name="ShortTitle" value={localizationStoreData.ShortTitle} onChange={onChangeLocalization} />
            </div>
          </div>
          <div className="row mb-3 mt-2">
            <div className="col-5">
              <label htmlFor="TabView">{lang.genre_label}</label>
              <MultiSelect
                data={filterGenres}
                name={"Genres"}
                textField="Description"
                dataItemKey="_id"
                value={localizationStoreData.Genres}
                onChange={onChangeLocalization} />
            </div>
            <div className="col-1" style={{ padding: '0px' }}>
              <button type="button" title={lang.create_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                style={{ height: "30px", margin: '20px 0px 0px 0px' }} onClick={() => { setShowGenreForm(true) }}><i className="fa-solid fa-plus fa-xs"></i>
              </button>
            </div>
            <div className="col-5">
              <label htmlFor="TabView">{lang.sub_genre_label} </label>
              <MultiSelect
                data={filterGenres}
                name={"SubGenres"}
                textField="Description"
                dataItemKey="_id"
                value={localizationStoreData.SubGenres}
                onChange={onChangeLocalization} />
            </div>
            <div className="col-1" style={{ padding: '0px' }}>
              <button type="button" title={lang.create_sub_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                style={{ height: "30px", margin: '20px 0px 0px 0px' }} onClick={() => { setShowGenreForm(true) }}><i className="fa-solid fa-plus fa-xs"></i>
              </button>
            </div>
          </div>
        </div>
        <MediaEpisodeMataDataEditForm language={localizationStoreData?.Language ?? {}} mediaData={mediaEpisodeEntity} metaData={localizationStoreData.MetaData} getMetaData={handleMetaDataLocaliztaion} />
      </BossDialog>
      }

      {showOttAssetEditForm && <CustomEditForm
        {...props} //to get other props from customEditForm
        cancelEdit={(setShowOttAssetEditForm(false))}
        // onSubmit={handleSubmit} //ERROR
        onSubmit={() => { }} //ERROR
      //  item={editItem}
      />}
      {attachedMediaOpen && <AttachMediaCollectionSelection hideSeriesSeason={true} addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} setDataList={handleAttachedMediaSelect} entityname={ENTITYNAME.MediaEpisode} closeForm={() => setAttachedMediaOpen(false)} width={"50vw"} />}
      {mediaTeplateOpen && <BossDialog
        title={lang.media_template_dialog_header}
        onClose={() => setMediaTeplateOpen(false)}
        width={"950px"}>
        <MediaTemplateEditForm mediaData={mediaEpisodeEntity} SID={mediaEpisodeEntity.SID} metaData={mediaEpisodeMetaData} getMetaData={handleMetaData} expand={handleExpand}></MediaTemplateEditForm></BossDialog>}
      {mediaTemplateSelectionOpen && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.select_media_template_collection_header} entityname={ENTITYNAME.MediaTemplate} wherestatement={['addBy._id', '=', utility.getValue(LOCALSTORAGE_KEY.user_id)]} closeForm={() => setMediaTemplateSelectionOpen(!mediaTemplateSelectionOpen)} setDataList={(dataList) => onSetSelectedMediaEpisode(dataList)} mode={'single'} width={"50vw"} />}
      {showGenreForm && <GenreEditForm item={{ Language: localizationStoreData?.Language }} cancelEdit={() => setShowGenreForm(false)} refresh={() => loadCombo()} />}
    </div>
  </>);
}
